import { CUSTOMER_SERVICE_URL } from '../../utils/constants';

interface MarketUrlsMap {
  [host: string]: {
    customerService: string;
    giftCard?: string;
  };
}

export const MARKET_URLS_MAP: MarketUrlsMap = {
  'www.sembo.co.uk': {
    customerService: `${CUSTOMER_SERVICE_URL}/en/support/home`,
  },
  'www.sembo.se': {
    customerService: `${CUSTOMER_SERVICE_URL}/sv-SE/support/home`,
    giftCard: '/resor/presentkort',
  },
  'www.sembo.dk': {
    customerService: `${CUSTOMER_SERVICE_URL}/da/support/home`,
    giftCard: '/rejser/gavekort',
  },
  'www.sembo.de': {
    customerService: `${CUSTOMER_SERVICE_URL}/de/support/home`,
  },
  'www.sembo.at': {
    customerService: `${CUSTOMER_SERVICE_URL}/de/support/home`,
  },
  'www.sembo.no': {
    customerService: `${CUSTOMER_SERVICE_URL}/nb-NO/support/home`,
    giftCard: '/reiser/gavekort',
  },
  'www.sembo.es': {
    customerService: `${CUSTOMER_SERVICE_URL}/es/support/home`,
  },
  'www.sembo.hu': {
    customerService: `${CUSTOMER_SERVICE_URL}/en/support/home`,
  },
  'www.sembo.com': {
    customerService: `${CUSTOMER_SERVICE_URL}/en/support/home`,
  },
  'www.sembo.nl': {
    customerService: `${CUSTOMER_SERVICE_URL}/nl/support/home`,
  },
  'www.sembo.ie': {
    customerService: `${CUSTOMER_SERVICE_URL}/en/support/home`,
  },
  'www.sembo.fi': {
    customerService: `${CUSTOMER_SERVICE_URL}/fi/support/home`,
  },
  'www.sembo.fr': {
    customerService: `${CUSTOMER_SERVICE_URL}/en/support/home`,
  },
  'www.sembo.nz': {
    customerService: `${CUSTOMER_SERVICE_URL}/en/support/home`,
  },
  'www.sembo.ca': {
    customerService: `${CUSTOMER_SERVICE_URL}/en/support/home`,
  },
  'www.sembo.com.au': {
    customerService: `${CUSTOMER_SERVICE_URL}/en/support/home`,
  },
  'ch.sembo.com': {
    customerService: `${CUSTOMER_SERVICE_URL}/de/support/home`,
  },
  'www.sembo.pl': {
    customerService: `${CUSTOMER_SERVICE_URL}/en/support/home`,
  },
  'www.sembo.pt': {
    customerService: `${CUSTOMER_SERVICE_URL}/en/support/home`,
  },
};
